import NoteList from "@/components/Notes/NoteList.vue";
import NoteEdit from "@/components/Notes/NoteEdit.vue";
import NoteFilter from "@/components/Notes/NoteFilter.vue";

export default [
    {
        path: 'note',
        alias: 'notes',
        name: 'All Notes',
        redirect: "/note/list",
        components: {
            page: NoteList,
        },
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: "filter",
                name: "Note Filter",
                components: {
                    modal: NoteFilter
                }
            },
            {
                path: "list/:filter?",
                name: "Note List",
                components: {
                    // ... NONE
                }
            },
            {
                path: "edit/:id",
                name: "Note Edit",
                components: {
                    modal: NoteEdit,
                }
            }
        ]
    }
];